/**
 * Свёрнута ли боковая панель разделов — единственное, что приложение помнит о пользователе
 * НА ЕГО КОМПЬЮТЕРЕ (CR-5, пакет 1).
 *
 * ГДЕ ЖИВЁТ И ПОЧЕМУ ИМЕННО ТАМ. Это не настройка учётной записи, а предпочтение рабочего места:
 * на сервер оно не уходит, в аудит не пишется, при входе с другого компьютера не переносится.
 * Хранилище браузера (localStorage) для этого и предназначено — до CR-5 приложение им не
 * пользовалось нигде, и этот модуль вводит соглашение: КЛЮЧ ЗАВОДИТСЯ ЗДЕСЬ, ОДИН НА СМЫСЛ,
 * с приставкой `kid.`, и читают его только через эти две функции. Разбредись обращения по
 * компонентам — и первая же опечатка в имени ключа станет молчаливой потерей настройки.
 *
 * ДВЕ ОГОВОРКИ, КОТОРЫЕ НАДО ЗНАТЬ ЗАРАНЕЕ (записаны и в плане CR-5):
 *   • компьютер общий — панель общая: состояние принадлежит браузеру, а не вошедшему;
 *   • две вкладки не синхронизируются: свернули в одной — вторая узнает после перезагрузки.
 * Оба следствия приемлемы для предпочтения показа и неприемлемы были бы для права или данных —
 * поэтому здесь и лежит ТОЛЬКО показ.
 *
 * ОТКАЗ ХРАНИЛИЩА — ШТАТНОЕ СОСТОЯНИЕ, А НЕ ОШИБКА. В приватном окне и при запрете хранения
 * сайту доступ к localStorage бросает исключение на самом обращении к свойству, поэтому в
 * try/catch завёрнуты и чтение, и запись: панель просто останется развёрнутой, без сообщений.
 */

/** Имя ключа. Экспортируется, чтобы тест проверял именно его, а не свою копию строки. */
export const SIDEBAR_COLLAPSED_KEY = "kid.nav.collapsed";

/** Умолчание: панель развёрнута — разделы видны подписями, а не одними значками. */
export const SIDEBAR_COLLAPSED_DEFAULT = false;

/** Прочитать состояние. Нет записи, чужое значение, недоступное хранилище → умолчание. */
export function readSidebarCollapsed(): boolean {
  try {
    const raw = window.localStorage.getItem(SIDEBAR_COLLAPSED_KEY);
    if (raw === "1") return true;
    if (raw === "0") return false;
    return SIDEBAR_COLLAPSED_DEFAULT;
  } catch {
    return SIDEBAR_COLLAPSED_DEFAULT;
  }
}

/** Запомнить состояние. Хранилище недоступно — молча живём без запоминания. */
export function writeSidebarCollapsed(collapsed: boolean): void {
  try {
    window.localStorage.setItem(SIDEBAR_COLLAPSED_KEY, collapsed ? "1" : "0");
  } catch {
    /* приватное окно или запрет хранения — панель работает, просто не запоминается */
  }
}
